import styled from "styled-components";

export const DrawFloorPlanBaseWrapper = styled.div<{
  $theme?: string;
  $width?: number;
  $height?: number;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const ResourceDetailFloorPlanWrapper = styled.div<{
  $theme?: string;
  $colorBorder?: string;
}>`
  width: 100%;
  border-left: 3px solid ${(props) => props.$colorBorder};
  padding-left: 4px;
`;

export const ResourceDetailFloorPlanNameWrapper = styled.div<{
  $theme?: string;
}>`
  width: 100%;
  display: flex;
  word-break: break-word;
  .mr-4 {
    margin-right: 4px;
  }
  .w-100 {
    width: 100%;
  }
  .d-flex {
    display: flex;
  }
`;

export const ResourceDetailFloorPlanLocationWrapper = styled.div<{
  $theme?: string;
}>`
  width: 100%;
  display: flex;
  word-break: break-word;
  .w-100 {
    width: 100%;
  }
`;

export const ResourceDetailFloorPlanEmailWrapper = styled.div<{
  $theme?: string;
}>`
  width: 100%;
  display: flex;
  word-break: break-word;
  .w-100 {
    width: 100%;
  }
`;

export const TextWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  margin-left: 4px;
  margin-right: 4px;
`;

export const HeaderActionWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  width: 100%;
  justify-content: end;
  margin-bottom: -6px;
  margin-top: -8px;
  margin-right: -8px;
  .icon-action {
    margin-right: -4px;
    cursor: pointer;
  }
`;

export const LayerZoomWrapper = styled.div<{ $theme?: string }>`
  font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI",
    -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  inset: 0px;
  position: absolute;
  color: white;
  background-color: rgba(4, 0, 0, 0.6);
  display: flex;
  align-items: center;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.9);
  flex-direction: column;
  justify-content: center;
  .ctrl-key {
    font-weight: bold;
    background: #0000005e;
    padding: 2px;
    border-radius: 4px;
  }
`;
